import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/store/auth";
import { useUserStore } from "@/store/user";

export default {
  data() {
    return {
      pageNo: 1,
      limit: 10,
      paginationOptions: ["5", "10", "20", "50", "100"],

      selectedFilterValue: null,
      overallLoading: false,
    };
  },

  methods: {
    ...mapActions(useUserStore, ["storeEditData", "clearEditData"]),
    ...mapActions(useAuthStore, ["startLoading", "stopLoading"]),

    setPageNo(value) {
      this.pageNo = value;
    },

    setLimit(value) {
      this.limit = value;
    },

    startOverallLoading() {
      this.overallLoading = true;
    },

    stopOverallLoading() {
      this.overallLoading = false;
    },

    openDeleteDialog(value) {
      this.$refs.deleteDialog.openDialog(value);
    },

    handleApplyFilters(selected) {
      this.selectedFilterValue = selected.value;
    },

    add(route) {
      this.clearEditData();
      this.$router.push(`${route}`);
    },

    async fetch(pageNo, api, options = {}) {
      this.startLoading();

      if (pageNo !== 0) {
        this.setPageNo(pageNo);
      }

      try {
        const response = await api({
          page_no: this.pageNo,
          limit: this.limit,
          ...options,
        });

        return response.success || response.status
          ? response
          : { data: [], ...response };
      } finally {
        this.stopLoading(); 
      }
    },

    async update(api, ID, route, param = null) {
      this.startOverallLoading();
      const response = await api(ID);

      if (response.success || response.status) {
        this.storeEditData(response.data);

        if (param) {
          this.$router.push(`${route}/${response.data[param]}`);
        } else {
          this.$router.push(route);
        }
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }

      this.stopOverallLoading();
    },

    async delete(api, ID) {
      this.startLoading();
      const response = await api(ID);
      if (response.status || response.success) {
        await this.fetchList(1);
        this.$refs.toast.showToast(response.message, "success");
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }
      this.stopLoading();
    },

    async updateStatus(api, id, data) {
      this.startLoading();

      const response = await api(id, {
        is_active: data.status === "Active" ? false : true,
      });

      if (response.success || response.status) {
        await this.fetchList(1);
        this.$refs.toast.showToast(`Status Updated Successfully`, "success");
      } else {
        this.$refs.toast.showToast(`Failed to update status`, "error");
      }

      this.stopLoading();
    },
  },

  computed: {
    ...mapState(useAuthStore, ["ldata", "loading"]),

    limitProxy: {
      get() {
        return this.limit;
      },
      set(value) {
        this.setLimit(Number(value));
        this.fetchList(1);
      },
    },
  },

  mounted() {
    this.fetchList(1);
  },
};
